export default {
      id: "arrow-special-full-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#arrow-special-full",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-special-full.svg
// module id = 125
// module chunks = 241 242 243